import { env } from '../env';

export const REACTIONS = env.REACT_APP_EK_ENV
  ? ['waving', 'clap', 'waving2', 'cooldance']
  : ['waving', 'clap', 'agreeing', 'victory', 'waving2', 'cooldance'];
